import React, { useEffect, useState, useRef } from "react";
import { apiUrl, PORT } from "../../environment";

import { AiFillDelete } from "react-icons/ai";
import "./AddMedia2.css";
import Form from "react-bootstrap/Form";

import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ProviderService from "../services/providerService";
import { formikAddMedia } from "./validation";
import { useFormik } from "formik";
import BackButton from "../../utils/BackButton";

function ViewMedia() {
  const navigate = useNavigate();
  const location = useLocation();
  const fileInputRef = useRef(null);
  const { media } = location.state || {};

  const [filePreview, setFilePreview] = useState([]);
  const [videoPreviews, setVideoPreviews] = useState([]);

  const [updatedData, setUpdatedData] = useState([]);

  const formik = useFormik({
    ...formikAddMedia,
    onSubmit: async (values) => {
      try {
        const formDataToSend = new FormData();
        formDataToSend.append("title", values.title);
        formDataToSend.append("shortDescription", values.shortDescription);
        formDataToSend.append("detailsDescription", values.detailsDescription);
        formDataToSend.append("category", values.category);
        formDataToSend.append("subCategory", values.subCategory);
        formDataToSend.append("mediaType", values.mediaType);

        values.files.forEach((file, index) => {
          formDataToSend.append("files", file);
        });

        if (media) {
          const res = await ProviderService.updateMedia(
            formDataToSend,
            media._id
          );

          if (res.data.status === "SUCCESS") {
            toast.success(res.data.message);
            navigate("/admin/media-management");
          } else {
            toast.error(res.data.message);
          }
        } else {
          const res = await ProviderService.addMedia(formDataToSend);

          if (res.data.status === "SUCCESS") {
            toast.success(res.data.message);
            navigate("/admin/media-management");
          } else {
            toast.error(res.data.message);
          }
        }
      } catch (error) {
        toast.error("Failed!");
      }
    },
  });

  // Handle file deletion
  const handleDeleteFile = (index, type) => {
    if (type === "image") {
      const updatedFiles = [...filePreview];
      updatedFiles.splice(index, 1);
      formik.setFieldValue("files", updatedFiles);

      const updatedPreviews = [...filePreview];
      updatedPreviews.splice(index, 1);
      setFilePreview(updatedPreviews);
    }

    if (type === "video") {
      const updatedVideos = [...videoPreviews];
      updatedVideos.splice(index, 1);
      setVideoPreviews(updatedVideos);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear input field
    }
  };

  const checkMediaDetails = async () => {
    if (media) {
      formik.setValues({
        title: media.title || "",
        detailsDescription: media.description || "",
        category: media.category || "",
        subCategory: media.subCategory || "",
        mediaType: media.mediaType || "",
        files: media.mediaURL || [],
        oldFiles: media.mediaURL || [],
      });
    }
  };

  useEffect(() => {
    checkMediaDetails();
  }, [media, updatedData]);

  return (
    <div className="Dashboard-wrapper view-media-block">
      {/* doctor-page */}
      <div className="dashboard-insights">
        <BackButton />

        <Form className="form-block mt-2" onSubmit={formik.handleSubmit}>
          <div className="doctor-box">
            <Form.Group
              className="mb-3"
              controlId="formProfilePhoto"
            ></Form.Group>

            <div className="p-4">
              <div className="row mb-4">
                <div className="col-md-4">
                  <div className="form-control-area">
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInputFirstName"
                    >
                      <Form.Label className="details">
                        Title<span className="asterisk">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter title"
                        name="title"
                        keyField={"title"}
                        formik={formik}
                        value={formik.values.title}
                        // disabled
                      />
                      {formik.touched.title && formik.errors.title ? (
                        <div className="text-danger">{formik.errors.title}</div>
                      ) : null}
                    </Form.Group>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-control-area">
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlSelectCategory"
                    >
                      <Form.Label className="details">Category </Form.Label>
                      <Form.Control value={formik.values.category || ""} />
                    </Form.Group>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-control-area">
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlSelectsubCategory"
                    >
                      <Form.Label className="details">Sub Category </Form.Label>
                      <Form.Control
                        id="sub-category-autocomplete"
                        disabled={formik.values.category ? false : true}
                        value={formik.values.subCategory || ""}
                      />
                    </Form.Group>
                  </div>
                </div>
              </div>
              <div className="row mb-4">
                <div className="col-12">
                  <div className="form-control-area">
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInputMobile"
                    >
                      <Form.Label className="details pre-line">
                        Description<span className="asterisk">*</span>
                      </Form.Label>

                      <div
                        className="pre-line "
                        dangerouslySetInnerHTML={{
                          __html: formik.values.detailsDescription || "",
                        }} // Rendering HTML directly
                      ></div>
                    </Form.Group>
                  </div>
                </div>
              </div>
              {formik.values?.files?.length > 0 && (
                <div className="row mb-4">
                  <div className="col-md-4">
                    <div className="form-control-area">
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlSelectGender"
                      >
                        <Form.Label className="details">Media Type</Form.Label>
                        <Form.Control
                          className="selected-fields"
                          name="mediaType"
                          keyField={"mediaType"}
                          value={formik.values?.mediaType}
                        />
                      </Form.Group>
                    </div>
                  </div>
                </div>
              )}

              {/* Display selected files with previews */}
              {formik.values?.mediaType === "image" && (
                <div className="file-preview-container">
                  {filePreview.map((file, index) => (
                    <div key={index} className="file-preview-item">
                      <img
                        src={file}
                        alt={`Preview ${index}`}
                        className="file-preview-image"
                        style={{ maxWidth: "100px", marginRight: "10px" }}
                      />
                    </div>
                  ))}
                </div>
              )}
              {media?.mediaType === "image" && (
                <div className="file-preview-container">
                  {media?.mediaURL?.map((file, index) => (
                    <div key={index} className="file-preview-item">
                      <img
                        src={`${apiUrl}${PORT}/user-service/getimages/${file}`}
                        alt={`Preview ${index}`}
                        className="file-preview-image"
                        style={{ maxWidth: "100px", marginRight: "10px" }}
                      />
                    </div>
                  ))}
                </div>
              )}

              {/* display video preview  */}
              {formik.values?.mediaType === "video" && (
                <div className="file-preview-container mt-2 mb-2">
                  {videoPreviews.map((file, index) => (
                    <div key={index} className="file-preview-item">
                      <video
                        controls
                        width="100"
                        height="70"
                        src={file}
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          marginRight: "10px",
                        }}
                      ></video>

                      <AiFillDelete
                        style={{ cursor: "pointer" }}
                        className="text-danger delete-icon cursor"
                        onClick={() => handleDeleteFile(index, "video")}
                      />
                    </div>
                  ))}
                </div>
              )}

              {media?.mediaType === "video" && (
                <div className="file-preview-container">
                  {media?.mediaURL?.map((file, index) => (
                    <div key={index} className="file-preview-item">
                      <video
                        controls
                        width="100"
                        height="70"
                        src={`${apiUrl}${PORT}/user-service/getvideos/${file}`}
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          marginRight: "10px",
                        }}
                      ></video>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
}
export default ViewMedia;
